import image9 from "../images/Plant-1.jpeg";
import image10 from "../images/Plant-2.jpeg";
import image11 from "../images/Plant-3.jpeg";
import { useState } from "react";

const Plant = () => {
    const [block, setblock] = useState(false);

    function FullView(ImgLink){
        document.getElementById("FullImage5").src = ImgLink;
        setblock(true);
    }

    function CloseFullView(){
        setblock(false);
    }

    return ( 
        <>
            <div className="main-container">
                    <h2>Plant Hire</h2>
                    <div className="components-section">
                        <div className="comp">
                            <div className="list">
                                <ul>
                                    <li>We pride ourselves on being a forward thinking group of people who understand the key needs of contractors when renting equipment from a yellow plant equipment hire company. While the service we provide is similar to that of so many other companies, our core difference is in our team; a team that is 100% committed to supplying the best hire solutions for every customer. <br/> We rent out vehicles such as: ADTs 20, 30, 40; Front-end loader; TLB</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    
                    <h3>Image Gallary </h3>
                    <h5>(Click image for fullscreen)</h5>
                    <div className="images">
                        <img src={image9} onClick={() => FullView(image9)} alt=""/>
                        <img src={image10} onClick={() => FullView(image10)} alt=""/>
                        <img src={image11} onClick={() => FullView(image11)} alt=""/>
                    </div>
                    <div className="fullImageView" style={{display: block? "block" : "none"}}>
                        <img id="FullImage5" alt=""  />
                        <i className="fa fa-times CloseButton" onClick={() => CloseFullView()}></i>
                    </div>
                </div>
                <div className="end-section5">
                </div>
            </>
     );
}
 
export default Plant;